<template>
  <div class="banner" v-if="!modalClosed">
    <span
      >This site will be retired soon. To learn more about our products, please
      visit
      <a tabindex="0" href="https://Surface.com/Business"
        >Surface for Business</a
      >
      and
      <a tabindex="0" href="https://tco.exploresurface.microsoft.com/"
        >Surface TCO</a
      ></span
    >
    <button
      class="app-overlay-close"
      @click="modalClosed = true"
      tabindex="0"
      :aria-label="$t('accessibility.closeAlert')"
    >
      <img src="@/assets/close-x.svg" alt="" />
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalClosed: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  top: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.5);
  height: 24px;
}

.app-overlay-close {
  position: relative;
  left: 8px;
  top: 1px;
  border: 0;
  border-radius: 88%;
  background-color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  width: 20px;

  img {
    height: 10px;
    cursor: pointer;
    filter: brightness(100);
    width: 10px;
    position: relative;
    bottom: 1px;
    right: 1px;
  }
}
</style>
